module.exports = "<div class=\"menu_item no_items_label\">{{noDataText}}</div>";